import styles from "./disclaimer.module.css";

interface DisclaimerPageProps {
  returnToHomePage: () => void;
}

export const DisclaimerPage = (props: DisclaimerPageProps) => (
  <div className={styles.page}>
    <div className={styles.container}>
      <h1 className={styles.title}>Disclaimer</h1>

      <div className={styles.container}>
        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Initiatief</h3>
          <p className={styles.sectionText}>
            Opluchtpost is een particulier initiatief. We zijn niet verbonden aan instanties zoals de gemeente of
            hulpverlening. We zijn dan ook geen hulpverleners. Onze missie is om troost te bieden aan mede-inwoners van
            Harderwijk die dat nodig hebben. Meer kunnen we niet betekenen; als je meer nodig hebt, dan kun je het beste
            geschikte hulp proberen te zoeken. We geven daarvoor een paar suggesties onder FAQ, maar we adviseren daar verder
            niet over. Daarvoor zijn er andere organisaties.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Rechten</h3>
          <p className={styles.sectionText}>
            Je kunt geen rechten ontlenen aan je inzending bij Opluchtpost. We doen ons best om je brief te beantwoorden! We
            doen dit vrijwillig en er kan ook wel eens iets misgaan.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Website</h3>
          <p className={styles.sectionText}>
            Onze website is bedoeld om te informeren. Als je vragen hebt over het project kun je gebruik maken van de
            contactgegevens. De website is niet bedoeld voor inhoudelijke berichten over je persoonlijke situatie.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Privacy</h3>
          <p className={styles.sectionText}>
            We archiveren de brieven die binnenkomen bij Opluchtpost zorgvuldig en zonder adresgegevens. Heb je liever niet
            dat we je brief bewaren? Vermeld dit dan in je brief. Ook kun je altijd nog een bericht sturen dat je je brief
            wil laten vernietigen.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Links naar derden</h3>
          <p className={styles.sectionText}>
            Voor op de website opgenomen links naar websites of diensten van derden kan Opluchtpost geen aansprakelijkheid
            aanvaarden.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Auteursrechten</h3>
          <p className={styles.sectionText}>
            Alle rechten van intellectuele eigendom betreffende de website en de toegestuurde materialen liggen bij
            Opluchtpost. Delen op social media mag voor particuliere, niet-commerciële doeleinden, zolang er vermelding wordt
            gemaakt van Opluchtpost.
          </p>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Overig</h3>
          <p className={styles.sectionText}>Deze disclaimer kan van tijd tot tijd wijzigen.</p>
        </section>

        <div className={styles.buttonContainer}>
          <button type="button" onClick={props.returnToHomePage} className={styles.backButton}>
            Terug naar website
          </button>
        </div>
      </div>
    </div>
  </div>
);
